export default {
  props: {
    validarTamanho: Boolean,
    maxLength: {
      type: Number,
      required: false,
    },
    valueText: {
      type: String,
      default: null,
    },
  },
}
